import { cloneElement, type ForwardedRef, type JSX } from 'react';

import { type DropdownTargetRenderProps } from './types/dropdown';

export const DropdownClonedTarget = ({
  children,
  ref,
  ...props
}: {
  readonly children: JSX.Element;
  readonly ref?: ForwardedRef<HTMLButtonElement>;
} & DropdownTargetRenderProps['props']) =>
  cloneElement(children, {
    ...children.props,
    ...props,
    ref,
  } as {
    readonly ref: ForwardedRef<HTMLButtonElement>;
  } & DropdownTargetRenderProps['props']);
